import { useState } from '@wordpress/element';
import { calculateBonuses } from '../utils';

export default function ValorCompra( {
	possibleBono,
	setTicketValue,
	remainingBonos,
} ) {
	const [ possibleBonos, setPossibleBonos ] = possibleBono;
	const [ error, setError ] = useState( '' );

	const handleValorCompra = ( e ) => {
		e.preventDefault();
		// Leemos el valor de la compra y pasamos de la coma decimal al punto
		const readedValue =
			document
				.getElementById( 'valor-compra' )
				.value.replace( ',', '.' ) * 100;
		// Comrpobamos que el valor de la compra es un número y no está vacío.
		if ( isNaN( readedValue ) || readedValue === 0 ) {
			setError( 'El valor de la compra debe ser un número' );
			return;
		}
		setError( '' );
		setTicketValue( readedValue );
		setPossibleBonos( calculateBonuses( readedValue, remainingBonos ) );
	};

	return (
		<div className="sci-bcl-valor-compra">
			<h3>Valor de la compra: </h3>
			<form onSubmit={ handleValorCompra }>
				<input
					type="text"
					id="valor-compra"
					disabled={ possibleBonos ? true : false }
				/>
				<button id="set-valor-compra" className="sci-bcl-btn">
					Calcular
				</button>
			</form>
			{ possibleBonos && (
				<div className="sci-bcl-bonos-posibles">
					<p>
						Se pueden canjear{ ' ' }
						<strong>{ possibleBonos.quantity }</strong> bonos de{ ' ' }
						<strong>{ possibleBonos.type / 100 }€</strong>. El
						descuento máximo es de{ ' ' }
						<strong>{ possibleBonos.maxDiscount / 100 }€.</strong>
					</p>
				</div>
			) }
			{ error && <p style={ { color: 'red' } }>{ error }</p> }
		</div>
	);
}
